import store from '@/state/store'
// import axios from "axios";

export default [
    {
        path: '/dashboard',
        name: 'default',
        meta: { authRequired: false },
        component: () =>
            import ('./views/dashboards/default'),
    },
    {
        path: '/',
        name: 'dashboard',
        meta: { authRequired: false },
        component: () =>
            import ('./views/dashboards/combinedashboard'),
    },    
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('./views/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () =>
            import ('./views/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () =>
            import ('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {

                store.dispatch('auth/logout')

                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                        (route) => route.push('/login')
                    )
                    // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'default' } : {...routeFrom })
            },
        },
    },

    {
        path: '/update_password',
        name: 'Update Password',
        component: () =>
            import ('./views/account/update_password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },

    {
        path: '/businesslist',
        name: 'Business List',
        component: () =>
            import ('./views/account/businesslist'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },

    // {
    //     path: '/404',
    //     name: '404',
    //     component: require('./views/utility/404').default,
    // },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    // {
    //     path: '*',
    //     redirect: '404',
    // },
    {
        path: '/units/view',
        name: 'Product Units',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/units')
    },
    {
        path: '/categories/view',
        name: 'Product Categories',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/categories')
    },
    {
        path: '/business/products',
        name: 'Business Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/business')
    },
    {
        path: '/products/view',
        name: 'Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/products')
    },
    {
        path: '/products/search',
        name: 'Search Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/search_products')
    },
    {
        path: '/products/add',
        name: 'Add Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/add_products')
    },
    {
        path: '/products/units',
        name: 'ProductUnits',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/product_units')
    },
    {
        path: '/services/view',
        name: 'Services',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/services')
    },
    {
        path: '/suppliers/view',
        name: 'Suppliers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/suppliers')
    },
    {
        path: '/suppliers/supplierprofile/:id',
        name: 'Suppliers Profile',
        meta: { authRequired: true, permission: 'view_suppliers' },
        component: () =>
            import ('./views/accounts/supplierprofile')
    },
    {
        path: '/supplier/deposits',
        name: 'Supplier Deposits',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/supplier_deposit')
    },
    {
        path: '/supplierdeposit_details/:id',
        name: 'Supplier Deposit Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/supplierdeposit_details')
    },
     {
        path: '/supplier/descriptive_balancedetails/:id',
        name: 'Descriptive Supplier Balance Details',
        meta: { authRequired: true, permission: 'view_supplierbalances' },
        component: () =>
            import ('./views/accounts/descriptive_balancedetails')
    },
    {
        path: '/supplier/print_descriptive_balancedetails/:id',
        name: 'Print Descriptive Supplier Balance Details',
        meta: { authRequired: true, permission: 'view_supplierbalances' },
        component: () =>
            import ('./views/accounts/descriptive_balance_detailsprint')
    },
    {
        path: '/supplier/print_balance_details/:id/:datefrom/:dateto',
        name: 'Print Supplier Balance Details',
        meta: { authRequired: true, permission: 'view_supplierbalances' },
        component: () =>
            import ('./views/accounts/balance_detailsprint')
    },
    {
        path: '/stock/view',
        name: 'Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/stock')
    },
    {
        path: '/stock/outof_stock',
        name: 'Out of Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/outof_stock')
    },
    {
        path: '/stock/in_stock',
        name: 'In Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/in_stock')
    },
    {
        path: '/purchase/new',
        name: 'New Purchase',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/new_purchase')
    },
    {
        path: '/purchase_details/:id',
        name: 'Purchase Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/purchase_details')
    },
    {
        path: '/stock/spoilt',
        name: 'Orders',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/spoilt_stock')
    },
    {
        path: '/stock/pendingspoilt',
        name: 'Pending SpoiltStock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/pending_spoiltstock')
    },
    {
        path: '/stock/rejectedspoilt',
        name: 'Rejected SpoiltStock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/rejected_spoiltstock')
    },
    {
        path: '/stock/shortExpiries',
        name: 'Short Expiries',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/short_expiries')
    },
    {
        path: '/stock/expired',
        name: 'ExpiredStock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/expired')
    },
    {
        path: '/stock/reconcile',
        name: 'Reconcile Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconcile')
    },
    {
        path: '/stock/reconcileall',
        name: 'Reconcile all Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconcileall')
    },
    {
        path: '/stock/stockvalue',
        name: 'Stock Value',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/stockvalue')
    },
    {
        path: '/reconciliation/report',
        name: 'Reconciliation Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconciliation_report')
    },
    {
        path: '/reconciliation/details/:id',
        name: 'Reconciliation Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconcile_details')
    },
    {
        path: '/reconciliation/summary',
        name: 'Reconciliation Summary Report',
        meta: { authRequired: true, permission: 'view_reconciliation_report' },
        component: () =>
            import ('./views/stock/reconcilesummary_report')
    },
    {
        path: '/unreconcileditems',
        name: 'Unreconciled Items Report',
        meta: { authRequired: true, permission: 'view_reconciliation_report' },
        component: () =>
            import ('./views/stock/unreconciled_items')
    },
    {
        path: '/shop/purchases',
        name: 'Shop Purchase Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/shop_purchase_report')
    },

    {
        path: '/advanced_reports/sellingprice_changes',
        name: 'Selling Price Changes Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/sellingprice_changes')
    },

    {
        path: '/advanced_reports/shopprice_changes',
        name: 'Shop Price Changes Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/shopprice_changes')
    },
    {
        path: '/advanced_reports/credit_payments',
        name: 'Credit Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/credit_payments')
    },
    {
        path: '/purchases/creditors',
        name: 'Creditors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/creditors')
    },

    {
        path: '/purchases/imported_creditors',
        name: 'Imported Creditors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/imported_creditors')
    },
    {
        path: '/creditor_details/:id',
        name: 'Imported Creditor Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/creditor_details')
    },
    //  store
    {
        path: '/store/add',
        name: 'Add To Store',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/new_purchase')
    },
    {
        path: '/store/view',
        name: 'Store',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/stock')
    },
    {
        path: '/store/reconcile',
        name: 'Reconcile Store',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/reconcile')
    },

    {
        path: '/store/purchases',
        name: 'Expired Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/store_purchases')
    },

    {
        path: '/advanced_reports/storeprice_changes',
        name: 'Store Price Changes Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/storeprice_changes')
    },
    {
        path: '/store/movements/:id',
        name: 'Store Stock Movements',
        meta: { authRequired: true, permission: 'view_store_stock' },
        component: () =>
            import ('./views/store/movements')
    },
    //  end store
    {
        path: '/cashin',
        name: 'CashIn',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/cashin')
    },
    {
        path: '/cashout',
        name: 'CashOut',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/cashout')
    },
    {
        path: '/supplierbalance_details/:id',
        name: 'SupplierBalance_details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/supplierbalance_details')
    },
    {
        path: '/supplier_balances',
        name: 'SupplierBalances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/supplierbalances')
    },
    {
        path: '/users/groups',
        name: 'Buy/sell',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/roles')
    },
    {
        path: '/users',
        name: 'Users',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/users')
    },
    {
        path: '/sales/order',
        name: 'NewOrder',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/sales')
    },
    {
        path: '/sale_details/:id',
        name: 'View Sales Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/sale_details')
    },
    {
        path: '/sales/confirm_order',
        name: 'Confirm Order',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/confirm_order')
    },
    {
        path: '/sales/readyorders',
        name: 'Ready Order',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/readyorders')
    },
    {
        path: '/sales',
        name: 'View Sales',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/sales_report')
    },
    {
        path: '/sales/discounts',
        name: 'View Sale Discounts',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/discount_allowed')
    },
    {
        path: '/payments',
        name: 'View Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/payments')
    },
    {
        path: '/purchase_payments',
        name: 'View Purchae Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/purchase_payments')
    },
    {
        path: '/sales/debtors',
        name: 'Debtors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/debtors')
    },
    {
        path: '/sales/imported_debtors',
        name: 'Imported Debtors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/imported_debtors')
    },
    {
        path: '/debtor_details/:id',
        name: 'Imported Debtors Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/debtor_details')
    },
    {
        path: '/sales/held',
        name: 'Held Sales',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/held_sales')
    },

    {
        path: '/advanced_reports/payments',
        name: 'Customer Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/payments_report')
    },
    {
        path: '/hold/print/:id',
        name: 'Invoice',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/invoice')
    },
    {
        path: '/messages',
        name: 'Message Center',
        meta: { authRequired: true },
        component: () =>
            import ('./views/messages/message_center')
    },
    {
        path: '/messages/buysms',
        name: 'MessageBuy',
        meta: { authRequired: true },
        component: () =>
            import ('./views/messages/buysms')
    },
    {
        path: '/lpo',
        name: 'Purchase Orders',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/lpo')
    },
    {
        path: '/lpo/new',
        name: 'New LPO',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/stock/new_lpo')
    },
    {
        path: '/lpo/details/:id',
        name: 'LPO Details',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/stock/lpo_details')
    },
    {
        path: '/lpo/print/:id',
        name: 'Print LPO',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/lpo_print')
    },
    {
        path: '/stock/transfer',
        name: 'Transfer Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/transfer_stock')
    },
    {
        path: '/stock/intransfer',
        name: 'Internal Stock Transfer',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/intransfer_stock')
    },
    {
        path: '/stock/transfer/direct',
        name: 'Direct Stock Transfer',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/direct_stock_transfer')
    },
    {
        path: '/stock/transfers',
        name: 'Stock Transfers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/transfers')
    },
    {
        path: '/stock/movement/:id',
        name: 'Stock Movement',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/stock/movements')
    },
    {
        path: '/audits',
        name: 'Audit Trails',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/audits')
    },
    {
        path: '/payment/options',
        name: 'PaymentOptions',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/payment_options')
    },
    {
        path: '/payment/transfers',
        name: 'MoneyTransfers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/money_transfers')
    },
    {
        path: '/paymentOptions/statement/:id',
        name: 'ModeStatement',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/mode_statement')
    },
    {
        path: '/retail_outlets',
        name: 'Retail Outlets',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/retail_outlets')
    },
    {
        path: '/settings/general',
        name: 'General Settings',
        meta: { authRequired: true, permission: 'view_general_settings' },
        component: () =>
            import ('./views/settings/general_settings')
    },
    {
        path: '/settings/receipt',
        name: 'Receipt Settings',
        meta: { authRequired: true, permission: 'view_receipt_settings' },
        component: () =>
            import ('./views/settings/receipt_settings')
    },
    {
        path: '/customers',
        name: 'Customers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customers')
    },
    {
        path: '/customer/deposits',
        name: 'CustomerDeposit',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customer_deposit')
    },
    {
        path: '/customerdeposit_details/:id',
        name: 'CustomerDeposit Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/deposit_details')
    },
    {
        path: '/customer/balances',
        name: 'Customer Balances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customer_balance')
    },
    {
        path: '/customer/balance_details/:id',
        name: 'Customer Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/balance_details')
    },
     {
        path: '/customer/descriptive_balancedetails/:id',
        name: 'Descriptive Customer Balance Details',
        meta: { authRequired: true, permission: 'view_customer_balances' },
        component: () =>
            import ('./views/customers/descriptive_balancedetails')
    },
    {
        path: '/customer/print_descriptive_balancedetails/:id',
        name: 'Print Descriptive Customer Balance Details',
        meta: { authRequired: true, permission: 'view_customer_balances' },
        component: () =>
            import ('./views/customers/descriptive_balance_detailsprint')
    },
    {
        path: '/missed_customers',
        name: 'Missed Customers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/missed_customers')
    },
    {
        path: '/customer_locations',
        name: 'Customer Locations',
        meta: { authRequired: true, setting: 'record_customerlocations', permission: 'record_customerlocations' },
        component: () =>
            import ('./views/customers/customer_locations')
    },
    {
        path: '/customer/deposit_refund',
        name: 'CustomerDeposit Refund',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customerdeposit_refund')
    },
    {
        path: '/refund_details/:id',
        name: 'CustomerDeposit Refund Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/deposit_refund_details')
    },
    {
        path: '/customer/print_balance_details/:id',
        name: 'Print Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/balance_detailsprint')
    },
    {
        path: '/customer/customer_profile/:id',
        name: 'Customer History',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customer_profile')
    },
    {
        path: '/expenses/categories',
        name: 'ExpenseCategories',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/categories')
    },
    {
        path: '/expenses/view',
        name: 'Expenses',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/expenses')
    },
    {
        path: '/expenses/report',
        name: 'Expense Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/report')
    },
    {
        path: '/expenses/agentexpenses',
        name: 'Agent Expenses',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/agentexpenses')
    },
    {
        path: '/expenses/record',
        name: 'Record Expenses',
        meta: { authRequired: true, permission: 'add_expenses' },
        component: () =>
            import ('./views/expenses/record_expenses')
    },
    {
        path: '/expenses/record_bulkexpenses',
        name: 'Expense Cart',
        meta: { authRequired: true, permission: 'add_expenses' },
        component: () =>
            import ('./views/expenses/expense_cart')
    },
     {
        path: '/expenses/creditors',
        name: 'Expense Creditors',
        meta: { authRequired: true, permission: 'view_expenses' },
        component: () =>
            import ('./views/expenses/creditors')
    },
    {
        path: '/expense_details/:id',
        name: 'Expenses Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/expense_details')
    },
    {
        path: '/expenses/expense_payments',
        name: 'Expense Payments',
        meta: { authRequired: true, permission: 'view_expenses' },
        component: () =>
            import ('./views/expenses/expense_payments')
    },
    // Advanced Reports
    {
        path: '/advanced_reports/debtors_report',
        name: 'Debtors Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/debtors_report')
    },
    {
        path: '/advanced_reports/creditors_report',
        name: 'Creditors Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/creditors_report')
    },
    {
        path: '/advanced_reports/expenses_report',
        name: 'Expenses Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/expenses_report')
    },
    {
        path: '/advanced_reports/held_sales_report',
        name: 'Held Sales Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/held_sales_report')
    },
    {
        path: '/advanced_reports/sales_report',
        name: 'Sales Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/sales_report')
    },
    {
        path: '/sales_vat_report',
        name: 'Sales VAT Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/sales_vat_report')
    },
    {
        path: '/advanced_reports/shop_purchases_report',
        name: 'Shop Purchases Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/shop_purchases_report')
    },
    {
        path: '/advanced_reports/store_purchases_report',
        name: 'Store Purchases Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/store_purchases_report')
    },
    {
        path: '/advanced_reports/stocktransfers_report',
        name: 'Stock Transfers Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/stocktransfers_report')
    },
    {
        path: '/advanced_reports/purchase_payments',
        name: 'Purchase payments Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/purchase_payments')
    },
    {
        path: '/advanced_reports/product_demand',
        name: 'Product demand Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/product_demand')
    },
    {
        path: '/advanced_reports/income_statement',
        name: 'Income statement',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/income_statement')
    },
    {
        path: '/advanced_reports/transactions_report',
        name: 'Transactions Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/transactions_report')
    },
    {
        path: '/advanced_reports/profitanalysis_report',
        name: 'Profit Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/profitanalysis_report')
    },
    {
        path: '/advanced_reports/salesanalysis_report',
        name: 'Sales Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/salesanalysis_report')
    },
    {
        path: '/advanced_reports/purchasereturns_report',
        name: 'Purchase Returns Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/purchasereturns_report')
    },
    {
        path: '/advanced_reports/salereturns_report',
        name: 'Sale Returns Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/salereturns_report')
    },
    {
        path: '/advanced_reports/advancedsales_report',
        name: 'Advanced Sales Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/advancedsales_report')
    },
    {
        path: '/advanced_reports/monthlysales_report',
        name: 'Monthly Sales Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlysales_report')
    },
    {
        path: '/advanced_reports/monthlysales_details/:date/:period',
        name: 'Monthly Sales Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlysales_details')
    },
    {
        path: '/advanced_reports/monthlyprofits_report',
        name: 'Monthly Profits Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlyprofits_report')
    },
    {
        path: '/advanced_reports/monthlyprofits_details/:date/:period',
        name: 'Monthly Profits Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlyprofits_details')
    },
    {
        path: '/users/permissions',
        name: 'Permissions',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/permissions')
    },
    {
        path: '/users/access_time',
        name: 'Accesstime',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/access_time')
    },
    // Consumables
    // {
    //     path: '/consumables/currentstock',
    //     name: 'Consumables Stock',
    //     meta: { authRequired: true },
    //     component: () =>
    //         import ('./views/consumables/currentstock')
    // },
    // {
    //     path: '/consumables/add_item',
    //     name: 'Add Consumable Items',
    //     meta: { authRequired: true },
    //     component: () =>
    //         import ('./views/consumables/add_item')
    // },
    // {
    //     path: '/consumables/stocking',
    //     name: 'Stock Consumables',
    //     meta: { authRequired: true },
    //     component: () =>
    //         import ('./views/consumables/stocking')
    // },
    // {
    //     path: '/consumables/usage',
    //     name: 'Use Consumables',
    //     meta: { authRequired: true },
    //     component: () =>
    //         import ('./views/consumables/usage')
    // },
    // {
    //     path: '/consumables/stocking_report',
    //     name: 'Consumable Stocking Report',
    //     meta: { authRequired: true },
    //     component: () =>
    //         import ('./views/consumables/stocking_report')
    // },
    // {
    //     path: '/consumables/usage_report',
    //     name: 'Consumables Usage Report',
    //     meta: { authRequired: true },
    //     component: () =>
    //         import ('./views/consumables/usage_report')
    // },
    {
        path: '/consumables/currentstock',
        name: 'Consumables Stock',
        meta: { authRequired: true, permission: 'stocking_report' },
        component: () =>
            import ('./views/consumables/currentstock')
    },
    {
        path: '/consumables/add_item',
        name: 'Add Consumable Items',
        meta: { authRequired: true, permission: 'add_consumable_items' },
        component: () =>
            import ('./views/consumables/add_item')
    },
    {
        path: '/consumables/item_units',
        name: 'Consumable Item Units',
        meta: { authRequired: true, permission: 'add_consumable_items' },
        component: () =>
            import ('./views/consumables/item_units')
    },
    {
        path: '/consumables/stocking',
        name: 'Stock Consumables',
        meta: { authRequired: true, permission: 'stocking_consumables' },
        component: () =>
            import ('./views/consumables/stocking')
    },
    {
        path: '/consumables/usage',
        name: 'Use Consumables',
        meta: { authRequired: true, permission: 'using_consumables' },
        component: () =>
            import ('./views/consumables/usage')
    },
    {
        path: '/consumables/stocking_report',
        name: 'Consumable Stocking Report',
        meta: { authRequired: true, permission: 'stocking_report' },
        component: () =>
            import ('./views/consumables/stocking_report')
    },
    {
        path: '/consumables/purchases_report',
        name: 'Consumable Purchases Report',
        meta: { authRequired: true, permission: 'stocking_report' },
        component: () =>
            import ('./views/consumables/purchases_report')
    },
    {
        path: '/consumables/usage_report',
        name: 'Consumables Usage Report',
        meta: { authRequired: true, permission: 'usage_report' },
        component: () =>
            import ('./views/consumables/usage_report')
    },
    {
        path: '/consumables/creditors',
        name: 'Consumables Credtors',
        meta: { authRequired: true, permission: 'stocking_consumables' },
        component: () =>
            import ('./views/consumables/creditors')
    },
    {
        path: '/consumables/setingredients',
        name: 'Set Ingredients',
        meta: { authRequired: true, permission: 'set_ingredients' },
        component: () =>
            import ('./views/consumables/set_ingredients')
    },
    {
        path: '/consumables/ingredients',
        name: 'Ingredients',
        meta: { authRequired: true, permission: 'set_ingredients' },
        component: () =>
            import ('./views/consumables/ingredients')
    },
    {
        path: '/consumables/output',
        name: 'Output',
        meta: { authRequired: true, permission: 'record_output' },
        component: () =>
            import ('./views/consumables/output')
    },
    {
        path: '/consumables/spoilt',
        name: 'Spoilt Consumables',
        meta: { authRequired: true, permission: 'view_spoilt_consumables' },
        component: () =>
            import ('./views/consumables/spoilt_stock')
    },
    {
        path: '/consumables/pendingspoilt',
        name: 'Pending SpoiltConsumables',
        meta: { authRequired: true, permission: 'view_spoilt_consumables' },
        component: () =>
            import ('./views/consumables/pending_spoiltstock')
    },
    {
        path: '/consumables/rejectedspoilt',
        name: 'Rejected SpoiltConsumables',
        meta: { authRequired: true, permission: 'view_spoilt_consumables' },
        component: () =>
            import ('./views/consumables/rejected_spoiltstock')
    },
    {
        path: '/consumables/reconcile',
        name: 'Reconcile Consumables',
        meta: { authRequired: true, permission: 'reconcile_consumables_stock' },
        component: () =>
            import ('./views/consumables/reconcile')
    },

    {
        path: '/consumables/movement/:id',
        name: 'Consumables Stock Movement',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/consumables/movements')
    },
    {
        path: '/consumables/make_order',
        name: 'Make Order',
        meta: { authRequired: true, permission: 'add_shop_stock' },
        component: () =>
            import ('./views/consumables/make_order')
    },
    {
        path: '/consumables/production_orders',
        name: 'Production Orders',
        meta: { authRequired: true, permission: 'view_shop_stock' },
        component: () =>
            import ('./views/consumables/production_orders')
    },
    {
        path: '/consumables/manufacturing_report',
        name: 'Manufacturing Report',
        meta: { authRequired: true, permission: 'view_incomestatement' },
        component: () =>
            import ('./views/consumables/manufacturing_report')
    },

    // agent accounts
    {
        path: '/agent_collections',
        name: 'Agents Collections',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agentaccounts/agent_collections')
    },
    {
        path: '/agent_balances',
        name: 'Agents Balances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agentaccounts/agent_balances')
    },
    {
        path: '/agent_balancedetails/:id',
        name: 'Agents Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agentaccounts/balance_details')
    },


    // Agent Stock
    {
        path: '/agent_stock/stock',
        name: 'Agents stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/stock')
    },
    {
        path: '/agent_stock/stockvalue',
        name: 'Agents stock value',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/stockvalue')
    },
    {
        path: '/agent_stock/disburse',
        name: 'Disburse',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/disburse')
    },
    {
        path: '/agent_stock/disbursements',
        name: 'Disbursements',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/disbursements')
    },
    {
        path: '/agent_stock/reconcile_stock',
        name: 'Reconcile stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/reconcile_stock')
    },
    {
        path: '/agent_stock/reconcilation_report',
        name: 'Reconcilation report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/reconcilation_report')
    },
    {
        path: '/agent_stock/reconcile_details/:id',
        name: 'Reconcilation details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/reconcile_details')
    },
    {
        path: '/agent_stock/damages',
        name: 'Damages',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/damages')
    },
    {
        path: '/agent_stock/return_stock',
        name: 'Return Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/return_stock')
    },
    {
        path: '/agent_stock/stock_returns',
        name: 'Agent stock returns',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/stock_returns')
    },
    {
        path: '/sales/agentsale',
        name: 'Agent sale',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/agentsale')
    },
    {
        path: '/sales/view_salereturns/:id',
        name: 'View Sales Returns',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/view_salereturns')
    },

    // Routes for financial statements
    {
        path: '/coa/newaccount',
        name: 'New Account',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/newaccount')
    },
    {
        path: '/coa/trialbalance',
        name: 'Trial Balance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/trialbalance')
    },
    {
        path: '/coa/income_statement',
        name: 'Income Statement',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/income_statement')
    },
    {
        path: '/coa/transaction_details/:id',
        name: 'Transaction Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/transaction_details')
    },
    {
        path: '/coa/balance_sheet',
        name: 'Balance Sheet',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/balance_sheet')
    },

    // Quotations and Invoices
    {
        path: '/quotations/new',
        name: 'New Quotation',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/quotations/new_quotation')
    },
    {
        path: '/quotations/view',
        name: 'Quotatiosa',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/quotations/quotations')
    },
    {
        path: '/quotation/details/:id',
        name: 'Quotation Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/quotations/quotation_details')
    },
    {
        path: '/printquotation/:id',
        name: 'Print Quotation',
        meta: { authRequired: true },
        component: () =>
            import ('./views/quotations/quotation_print')
    },
    {
        path: '/invoices',
        name: 'View Invoice',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/invoices/invoices')
    },
    {
        path: '/invoice_details/:id',
        name: 'Print Invoice',
        meta: { authRequired: true },
        component: () =>
            import ('./views/invoices/invoice_details')
    },
    {
        path: '/printdeliverynote/:id',
        name: 'Print Delivery Note',
        meta: { authRequired: true, permission: 'new_sale' },
        component: () =>
            import ('./views/sales/deliverynote_print')
    },
    {
        path: '/sales/viewsale/:id',
        name: 'View Sale',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/receipt_details')
    },
    // Staff section
    {
        path: '/staff',
        name: 'Staff',
        meta: { authRequired: true, permission: 'view_staff', setting: 'manage_staff' },
        component: () =>
            import ('./views/staff/staff')
    },
    {
        path: '/staffpositions',
        name: 'Staff Positions',
        meta: { authRequired: true, permission: 'view_staff', setting: 'manage_staff' },
        component: () =>
            import ('./views/staff/staffpositions')
    },
    {
        path: '/staffpayroll',
        name: 'Staff Payroll',
        meta: { authRequired: true, permission: 'view_staff_payroll', setting: 'manage_staff' },
        component: () =>
            import ('./views/staff/staffpayroll')
    },
    {
        path: '/staffadvances',
        name: 'Staff Advances',
        meta: { authRequired: true, permission: 'view_staff_advances', setting: 'manage_staff' },
        component: () =>
            import ('./views/staff/staffadvances')
    },
    {
        path: '/staffsalaries',
        name: 'Staff Salaries',
        meta: { authRequired: true, permission: 'view_staff_salaries', setting: 'manage_staff' },
        component: () =>
            import ('./views/staff/staffsalaries')
    },
    {
        path: '/staffallowances',
        name: 'Staff Allowances',
        meta: { authRequired: true, permission: 'view_staff_salaries', setting: 'manage_staff' },
        component: () =>
            import ('./views/staff/staffallowances')
    },
    {
        path: '/monthly_staffsalaries',
        name: 'Monthly Staff Salaries',
        meta: { authRequired: true, permission: 'view_staff_salaries', setting: 'manage_staff' },
        component: () =>
            import ('./views/staff/monthly_staffsalaries')
    },

]